const assetsConfig = {
    logo : require("../static/logo.jpg"),
    noData : require("../static/no_data.png"),
    noNotice : require("../static/no_notice.png"),
    defaultAvatar: require("../static/avatar.png"),
    spliterLine: require("../static/spliter-line.png")
}

export default assetsConfig;
